import { DietType } from "../diets";

export const dietsEs: DietType[] = [
    {
        id: "keto",
        name: "Keto",
        description: "Dieta alta en grasas y baja en carbohidratos",
        objective: "Pérdida de peso y regulación del azúcar en sangre",
    },
    {
        id: "vegetarian",
        name: "Vegetariana",
        description: "Alimentación basada en plantas rica en nutrientes",
        objective:
            "Mejora de la salud general y reducción del impacto ambiental",
    },
    {
        id: "paleo",
        name: "Paleo",
        description:
            "Alimentos integrales basados en la alimentación ancestral",
        objective: "Pérdida de peso y reducción de la inflamación",
    },
    {
        id: "lowcarb",
        name: "Baja en Carbohidratos",
        description: "Dieta baja en carbohidratos con proteínas y grasas",
        objective: "Pérdida de peso o mantenimiento",
    },
    {
        id: "mediterranean",
        name: "Mediterránea",
        description:
            "Dieta basada en alimentos integrales, aceite de oliva, pescado y frutos secos",
        objective: "Salud cardiovascular y mantenimiento",
    },
    {
        id: "intermittentfasting",
        name: "Ayuno Intermitente",
        description: "Alternancia de períodos de ayuno y alimentación",
        objective: "Control calórico y pérdida de grasa",
    },
    {
        id: "highprotein",
        name: "Alta en Proteínas",
        description: "Dieta alta en proteínas para preservar la masa muscular",
        objective: "Desarrollo y mantenimiento muscular",
    },
    {
        id: "zone",
        name: "Zona",
        description: "Equilibrio 40% carbohidratos, 30% proteínas y 30% grasas",
        objective: "Estabilización del azúcar en sangre y control de peso",
    },
    {
        id: "vegan",
        name: "Vegana",
        description: "Dieta completamente basada en plantas",
        objective: "Salud general y sostenibilidad ambiental",
    },
    {
        id: "carnivore",
        name: "Carnívora",
        description: "Dieta basada solo en carne, pescado y productos animales",
        objective: "Pérdida de peso extrema y reducción de la inflamación",
    },
    {
        id: "flexible",
        name: "Dieta Flexible",
        description: "Alimentación flexible que respeta los macronutrientes",
        objective: "Flexibilidad para objetivos estéticos o deportivos",
    },
    {
        id: "dash",
        name: "DASH",
        description: "Dieta rica en frutas, verduras y cereales integrales",
        objective: "Salud cardiovascular y reducción de la hipertensión",
    },
];
